<template>
  <div id='bill'>
    <div>
      <div class="content-title">
        <Icon type="android-settings"></Icon>應收帳款
        <div class="border"></div>
      </div>
      <Select v-model="teamId" style="width:200px" placeholder="請選擇客戶" @on-query-change="getBillList">
        <Option v-for="t in teamList" :value="t.id" :key="t.id">{{ t.name }}</Option>
      </Select>
      <br><br>
      <Table border :columns="column" :data="billList"></Table>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";
import moment from "moment";

export default {
  name: "bill",
  data() {
    return {
      teamId: -1,
      teamList: [],
      column: [
        { title: '預結帳日', key: 'closing_date' },
        { title: '應收金額', key: 'payment' },
        { title: '轉出帳單', key: 'bill' }
        // { title: '備註', key: 'note' },
      ],
      billList: [],
      viewData: []
      
    };
  },
  created() {
    this.getTeamList()
  },
  methods: {
    async getTeamList() {
      let res = await this.axios.get(API.teams)
      this.teamList = res.data.teamList

    },
    async getBillList() {
      let res = await this.axios.get(API.bills + `${this.teamId}`)
      this.billList = res.data.map(bill => {
        
        console.log(bill.closing_date)
        bill.closing_date = moment(bill.closing_date).format("YYYY-MM-DD"); 
        return bill
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ivu-row {
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/bill/bill.vue